export const setNumberFormat = (number, convention = 'es-ES') => {
    const formatter = new Intl.NumberFormat(convention, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })

    return formatter.format(number);
}